module.exports = __webpack_public_path__ + "img/bg-friend2.jpg";